<template>
  <div v-if="open" class="select-list">
    <div
      style="background: #fff; border: 1px solid #ccc;overflow-y: scroll; width: 100%; height: 270px;"
    >
      <div
        @click="selected"
        v-for="(item, index) in list"
        :key="index"
        class="q-pa-md text-primary cursor-pointer select-item"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectItem: null,
    };
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selected(e) {
      this.selectItem = e.target.innerText;
      this.$emit("selected", this.selectItem);
    },
  },
};
</script>

<style scoped>
.select-list {
  position: absolute;
  width: 100%;
  top: 80px;
  left: 0;
  z-index: 100;
  padding: 1rem 0 0 1rem;
}
.select-item:hover {
  background: #ccc;
}
</style>
